import React from 'react';
import { Popover } from 'antd';
import { RollbackOutlined } from '@ant-design/icons';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventName } from '../../../section/Common/constants';

interface IProps {
  book: IBook;
  id: string;
}

const Return: React.FC<IProps> = ({ book, id }) => {
  const { setAction } = useActions();
  const isManuallyAdded = book?.['Secondary Tags']?.includes('Manually Added');
  let returnTo = 'All New titles';

  if (isManuallyAdded) {
    returnTo = 'Manually Added';
  } else if (window.location.pathname.includes('royal-road')) {
    returnTo = 'All Titles';
  }

  return (
    <Popover
      placement='topLeft'
      content={
        <div className='popover-content'>
          {`Return title to ${returnTo}`}
        </div>
      }
      trigger='hover'
    >
      <RollbackOutlined
        data-testid='action-return-item'
        onClick={(e) => {
          e.stopPropagation();
          globalThis.gtag('event', GAEventName.click, {
            identifier: `Return title to ${returnTo}`,
            value: book.ASIN,
            book_name: book.Title
          });
          setAction({ book, id, type: ACTIONS.return });
        }}
        className='actions-icons actions-icons-return'
      />
    </Popover>
  );
};

export default React.memo(Return);